module.exports = __webpack_public_path__ + "img/bg4.cc3643bb.png";